//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.12.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .factory('tableColumnNumberFilterService', tableColumnNumberFilterService);

    function tableColumnNumberFilterService(sortService, MegaTableItemProperty) {

        let service = {};

        service.filter = data => {

            let filteredItems = data.unfilteredItems.slice();

            // Filter by number
            filteredItems = filteredItems.filter(item => {
                
                let textItem = data.textItems.find(textItem => textItem[data.columnKey] == item[data.columnKey]);               
                return !textItem[MegaTableItemProperty.HIDDEN];
            });

            // Filter by number
            if (data.searchText) {                
                let searchText = data.searchText.toLowerCase(); 
                filteredItems = filteredItems.filter(item => item[data.columnKey] && item[data.columnKey].toString().toLowerCase().indexOf(searchText) > -1);
            }

            // Sort by direction
            if (data.column.sortDirection) {
                filteredItems = sortService.sortItemsByNumber(filteredItems, data.columnKey, data.column.sortDirection);
            }

            data.itemsFiltered(filteredItems);
        };

        return service;
    }
})();